import React, { Fragment } from 'react'
import { Breadcrumb, Button, Icon, Empty } from 'antd'
import { RouteComponentProps } from 'react-router'
import { filter, isEmpty } from 'lodash'
import { ComponentExt } from 'util/reactExt'
import VPlayer from 'components/VPlayer'
import * as styles from './index.scss'

interface IProps extends RouteComponentProps<any> {}
interface IState {
  renderPage: any
  sectionList: any
  sectionItem: {
    name: any
    label_name: any
    is_exam: number
    is_study: number
    label: number
    exam: {
      exam_url: string
      is_can_exam: number
      is_need_exam: number
    }
  }
  content: {
    name: string
    content: any
    id: number | null
    videoInfo?: {
      id: number | null
      content: string
      random: string
    }
  }
}

class CourseCheck extends ComponentExt<IProps, IState> {
  state = {
    renderPage: null,
    sectionList: [],
    sectionItem: {
      name: '',
      label_name: '',
      exam_id: 62,
      is_exam: 1,
      is_study: 2,
      label: 1,
      exam: {
        exam_url: '',
        is_can_exam: 0,
        is_need_exam: 0,
      },
    },
    content: {
      name: '',
      content: null,
      id: null,
      videoInfo: {
        id: null,
        content: '',
        random: '',
      },
    },
  }

  private timer

  componentDidMount() {
    clearTimeout(this.timer)
    this.handleSectionList(true)
    this.handleSectionTitle()
  }

  // 考核标题
  handleSectionTitle = async () => {
    const id = new URLSearchParams(this.props.location.search).get('id')
    try {
      const section = await this.api.lecturer.getLecturerStudySection({})
      const [sectionItem] = filter(section, { id: Number(id) })
      const obj = JSON.parse(JSON.stringify(sectionItem))
      this.setState({ sectionItem: { ...obj } })
    } catch (err) {
      console.error(err.message)
    }
  }

  // 考核课程
  handleSectionList = async (first?: boolean) => {
    const id = new URLSearchParams(this.props.location.search).get('id')
    try {
      const sectionList = await this.api.lecturer.getLecturerStudySectionList({
        id,
      })
      if (first) {
        const [infoData] = filter(sectionList, { is_study: 2 })
        let info = {}
        if (infoData) {
          info = infoData
        } else {
          info = sectionList[0]
        }
        this.onClickSectionList(info)
      }
      this.setState({ sectionList })
    } catch (err) {
      console.error(err.message)
    }
  }

  renderArticleComponent = content => {
    if (isEmpty(content)) {
      ;<Empty description="暂无数据" style={{ paddingTop: '230px' }} />
    }
    const { type } = content
    if (type === 1) {
      return (
        <Fragment>
          <>
            <h2 className={styles.taskTitle}>{content.name}</h2>
            <div className={styles.taskContent}>
              <VPlayer
                type="video"
                src={content.videoInfo.content}
                onplay={this.onPlay}
              />
            </div>
            <Button className={styles.btn} onClick={this.onClickAffirmStudy}>
              我已观看
            </Button>
          </>
        </Fragment>
      )
    }

    if (type === 2) {
      return (
        <>
          <h2 className={styles.taskTitle}>{content.name}</h2>
          <div
            className={styles.taskContent}
            dangerouslySetInnerHTML={{ __html: content.content }}
          ></div>
          <Button className={styles.btn} onClick={this.onClickAffirmStudy}>
            我已学习
          </Button>
        </>
      )
    }
  }

  onPlay = () => {
    this.studying()
  }

  studying = () => {
    clearTimeout(this.timer)
    this.timer = setTimeout(async () => {
      const { id, random } = this.state.content.videoInfo
      this.api.article.statistics(id, random)
      this.studying()
    }, 60000)
  }

  // Tab点击
  onClickSectionList = async content => {
    if (content.is_study === 1) {
      return
    }
    if (content.type === 1) {
      try {
        const { data } = await this.api.lecturer.getLecturerStudySectionVideo({
          id: content.video_id,
        })
        content.videoInfo = data
      } catch (err) {
        console.error(err.message)
      }
    }
    const renderPage: any = this.renderArticleComponent(content)
    this.setState({
      content,
      renderPage,
    })
  }

  // 确认学习，并前往下一章
  onClickAffirmStudy = async () => {
    const {
      content: { id },
    } = this.state
    try {
      const { status, msg } = await this.api.lecturer.SubmitLecturerStudyAffirm(
        { id },
      )

      if (status === 1 || status === 5) {
        this.$message.success(msg)
        const pathId = new URLSearchParams(this.props.location.search).get('id')
        const section = await this.api.lecturer.getLecturerStudySectionList({
          id: pathId,
        })
        let next: any = {}
        let index = 0
        section.forEach((item, idx) => {
          if (item.id === id) {
            next = section[idx + 1] || {}
            index = idx + 1
          }
        })
        if (!isEmpty(next)) {
          this.onClickSectionList(next)
        }
        this.handleSectionList()
        this.handleSectionTitle()
      } else {
        this.$message.warning(msg)
      }
    } catch (err) {
      console.error(err.message)
    }
  }

  goExam = () => {
    const {
      sectionItem: {
        exam: { exam_url },
      },
    } = this.state
    window.open(exam_url)
  }

  render() {
    const { sectionItem, renderPage, sectionList, content } = this.state
    const {
      exam: { is_can_exam, is_need_exam },
    } = sectionItem

    return (
      <div className={styles.wrapper}>
        <div className="Breadcrumb">
          <Breadcrumb separator=">">
            <Breadcrumb.Item href="/#/study">专业学习</Breadcrumb.Item>
            <Breadcrumb.Item>考核课程</Breadcrumb.Item>
          </Breadcrumb>
        </div>

        <h2 className={styles.courseTitle}>
          {sectionItem.name}
          {sectionItem.label_name && (
            <span
              className={
                sectionItem.label_name === '软件'
                  ? styles.stock
                  : styles.software
              }
            >
              {sectionItem.label_name}
            </span>
          )}
        </h2>

        <div className={styles.courseWrap}>
          <div className={styles.catalogue}>
            <h2 className={styles.title}>课程目录</h2>
            <div className={styles.catalogueList}>
              <ul className={styles.list}>
                {sectionList.map(item => (
                  <li
                    key={item.id}
                    className={content.id === item.id ? styles.active : ''}
                    style={{
                      cursor: item.is_study === 1 ? 'not-allowed' : 'pointer',
                    }}
                    onClick={() => {
                      this.onClickSectionList(item)
                    }}
                  >
                    <span
                      className={styles.progress}
                      style={{
                        backgroundColor:
                          item.is_study === 2 || item.is_study === 3
                            ? '#3a9cff'
                            : '#d8d8d8',
                      }}
                    ></span>
                    <Icon
                      type={item.type === 1 ? 'play-square' : 'file-text'}
                      style={{
                        display: 'block',
                        float: 'left',
                        lineHeight: '50px',
                        marginRight: '10px',
                      }}
                    />
                    <span className={styles.text}>{item.name}</span>
                    {item.is_study === 2 && (
                      <Button
                        style={{
                          padding: '0 5px',
                          fontSize: 10,
                          height: 20,
                          borderColor: '#3a9cff',
                          color: '#3a9cff',
                        }}
                      >
                        进行中
                      </Button>
                    )}
                    {item.is_study === 3 && (
                      <Icon
                        type="check-circle"
                        style={{
                          float: 'right',
                          lineHeight: '50px',
                          display: 'block',
                          color: '#3a9cff',
                          fontSize: '20px',
                          paddingRight: '10px',
                        }}
                      />
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <Button
              type="primary"
              style={{
                display: 'block',
                width: '90%',
                height: 50,
                margin: '10px auto',
              }}
              disabled={!(is_can_exam === 1 && is_need_exam === 1)}
              onClick={this.goExam}
            >
              前往考试
            </Button>
          </div>
          <div className={styles.rightContent}>{renderPage}</div>
        </div>
      </div>
    )
  }
}

export default CourseCheck
